var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "app-footer"
  }, [_c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid clearfix"
  }, [_c('span', {
    staticClass: "text-muted d-block text-center text-sm-left d-sm-inline-block"
  }, [_vm._v(_vm._s(_vm.footerText))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }